// extracted by mini-css-extract-plugin
module.exports = {"container":"rS","content":"rT","title":"rU","mb60":"rV","listItem":"rW","listItemText":"rX","goBack":"rY","goBackText":"rZ","header":"r0","closeBtn":"r1","subcategoryBtn":"r2"};